import { BAND } from "../lib/constants";

// Semicircle instrument-panel gauge (mirrors the reference artifact)
export default function LeadScoreGauge({ score = 0, band = "cold" }) {
  const angle = -90 + (score / 100) * 180;
  const label = band.toUpperCase();
  const desc = {
    cold: "Stays in standard sequence — no elevated action.",
    warm: "Continue sequence — cadence may increase.",
    hot: "Qualified — Voice Agent triggers.",
    priority: "Voice Agent triggers + Sales Lead notified.",
  }[band];

  return (
    <div className="text-center" data-testid="lead-score-gauge">
      <svg width="100%" height="180" viewBox="0 0 360 200" className="overflow-visible">
        <path d="M 30 180 A 150 150 0 0 1 92.6 61.8" fill="none" stroke="#94A3AD" strokeWidth="16" strokeLinecap="round" />
        <path d="M 92.6 61.8 A 150 150 0 0 1 180 30" fill="none" stroke="#3E8F99" strokeWidth="16" strokeLinecap="round" />
        <path d="M 180 30 A 150 150 0 0 1 267.4 61.8" fill="none" stroke="#E2711D" strokeWidth="16" strokeLinecap="round" />
        <path d="M 267.4 61.8 A 150 150 0 0 1 330 180" fill="none" stroke="#B23A2E" strokeWidth="16" strokeLinecap="round" />
        <line x1="180" y1="180" x2="180" y2="55" stroke="#1C2530" strokeWidth="3" strokeLinecap="round"
          transform={`rotate(${angle} 180 180)`} style={{ transition: "transform .5s cubic-bezier(.3,.9,.3,1)" }} />
        <circle cx="180" cy="180" r="8" fill="#1C2530" />
      </svg>
      <div className="font-mono text-5xl font-bold -mt-2" style={{ color: BAND[band] }} data-testid="gauge-score">
        {score}
      </div>
      <div className="font-mono text-sm font-semibold tracking-widest mt-1" style={{ color: BAND[band] }}>
        {label}
      </div>
      <div className="text-xs text-[#1C2530]/60 mt-1 min-h-[32px] px-4">{desc}</div>
    </div>
  );
}
